import { cloudCode } from "@/modules/cloud";

type GetCameraHistory = {
  cameras?: string[];
  events?: string[];
  start?: number;
  end?: number;
  pageSize?: number;
};

export async function getCameraHistoryEvents({
  lastEventId,
  cameras,
  events,
  start,
  end,
  pageSize = 20
}: GetCameraHistory & { lastEventId?: string }) {
  const cameraEvents: ParseCameraEvent[] | null = await cloudCode.run("getCameraHistoryEvents", {
    pageSize,
    lastEventId,
    cameras,
    events,
    start,
    end
  });
  return cameraEvents;
}

export async function prepareCameraHistoryEventPlaylist(objectId: string) {
  const response: { allSegmentsUploaded: boolean; playlistUrl: string } = await cloudCode.run(
    "prepareCameraHistoryEventPlaylist",
    { objectId }
  );
  return response;
}

export async function getNewerCameraHistoryEvents({
  initialEventId,
  cameras,
  events
}: GetCameraHistory & { initialEventId?: string }) {
  const cameraEvents: ParseCameraEvent[] = await cloudCode.run("getNewerCameraHistoryEvents", {
    initialEventId,
    cameras,
    events
  });
  return cameraEvents;
}

export async function deleteCameraHistoryEvent(objectId: string) {
  const response = await cloudCode.run("deleteCameraHistoryEventByObjectId", {
    eventId: objectId
  });
  return response;
}

export async function deleteCameraHistoryEvents(objectIds: string[]) {
  const response = await cloudCode.run("deleteCameraHistoryEventsByObjectIds", {
    eventIds: objectIds
  });
  return response;
}

export async function getCameraHistoryEventByUniqueId({ uniqueId, jid }: { uniqueId: string; jid: string }) {
  const response: ParseCameraEvent = await cloudCode.run("getCameraHistoryEventByUniqueId", {
    uniqueId,
    cameraStationXmppLogin: jid
  });
  return response;
}
